import React from 'react';
import FounderHero from '../components/FounderHero';
import FounderMessageDetail from '../components/FounderMessageDetail';

const FounderMessage = () => {
  return (
    <div className="gfi-founder-message-page-wrapper">
      
      {/* 1. INITIAL CENTERED DUAL-TONE HERO BANNER BLOCK */}
      <FounderHero />
      <FounderMessageDetail />
      {/* 2. Future Components (Founder Speech, Profile Details) yahan aayenge */}

    </div>
  );
};

export default FounderMessage;